import * as React from 'react'
import { format } from 'date-fns'
import clx from 'classnames'

import { CalendarDateIcon } from '../icons/CalendarDate'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

export const CurrentDetailedDate = ({
  classNameDate,
  className,
}: {
  classNameDate?: string
  className?: string
}) => {
  const { t } = useLocalize()
  const [now, setNow] = React.useState(new Date())

  React.useEffect(() => {
    const timer = window.setInterval(() => {
      setNow(new Date())
    }, 1000)

    return () => window.clearInterval(timer)
  }, [])

  const week = format(now, 'WW')
  const dayName = format(now, 'dddd')
  const day = format(now, 'DD')
  const monthName = format(now, 'MMMM')
  const year = format(now, 'YYYY')
  const time = format(now, 'HH:mm:ss')
  const dayOfWeek = t(`dayOfWeek.${dayName.toLocaleLowerCase()}`)
  const month = t(`monthName.${monthName.toLocaleLowerCase()}`)
  return (
    <div
      className={clx(
        `tw-flex tw-min-w-0 tw-items-center tw-gap-1 tw-text-xs tw-tabular-nums sm:tw-text-sm`,
        className,
      )}
    >
      <div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
        <CalendarDateIcon className="tw-flex-shrink-0" />
        <span
          className={clx(
            'tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-1 tw-tabular-nums',
            classNameDate,
          )}
        >
          <span className="tw-hidden lg:tw-inline">
            {t('common.week')}: {week},
          </span>
          <span className="tw-hidden sm:tw-inline">{dayOfWeek},</span>
          <span className="tw-whitespace-nowrap">
            {day} {month}
            <span className="tw-hidden sm:tw-inline"> {year}</span>
          </span>
          <span className="tw-whitespace-nowrap">{time}</span>
        </span>
      </div>
    </div>
  )
}
